
import { useState, useRef } from "react";


function Print(props)
{


    function printElm(handle) {
        
     

        var html  = 
        "<html><head><title></title></head><body>" + 
        handle.outerHTML + "</body>";


            var win = window.open('', 'PrintWindow');
            win.document.write(html);

            setTimeout(function () {
                win.document.close();
                win.focus();
                win.print();
                win.close(); 
            }, 100);
              
    }

    const goPrint = () => {

        //const rows = props.tabRef.current?.rows;

        printElm(props.tabRef.current);
    }



    return (
        <span onClick={goPrint} className="plg_link">&nbsp;&nbsp;Wydruk&nbsp;&nbsp;</span>
    )
}


export default Print;